import { SecurityType } from "../../../../../../Wrap/Constants/Enums/Domain/Instrument/SecurityType";
import { ProductType } from "../../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { SubAccountTypeHelper } from "../../Common/Helpers/SubAccountTypeHelper";

export const switchStepperName = {
    orderStep: "Order setup",
    switchTo: "Switch to investments",
    switchFrom: "Switch from investments",
    review: "Review",
    confirmation: "Confirmation",
};

export const equlityBondWarning =
    "Your orders contain equity dealing instructions. A Market Order will be active for the remainder of the day in which it is placed with the execution-only stockbroker. A Limit Order will be active until the expiry date selected by you. Please note that Limit Orders have a maximum time period of 90 calendar days after which they will automatically expire. You will be advised of any expired or cancelled orders via your Reminders queue.";

export const hasDecisionMaker = (data) => {
    return (
        data &&
        data.some(
            (ele) =>
                ele.OrderValue > 0 &&
                ([SecurityType.Bond, SecurityType.Share].includes(ele.Instrument.Type) ||
                    [ProductType.Equity, ProductType.Bond].includes(ele.Instrument.Type))
        )
    );
};

export const needAdviceGivenForOffPlatform = (data, subAccountType) => {
    if (!SubAccountTypeHelper.isOnPlatformPension(subAccountType) ||
        !data || data.length == 0) {
        return false
    }
    return (
        data.some((ele) => [ProductType.OffPlatform].includes(ele.Instrument.Type) && ele.OrderValue > 0)
    );
}

export const orderAmendedMsg = "Order values greater than or equal to 95% have been amended to sell all units"
export const reviewExistingInstructionMsg = "After submitting a trade, please check any regular payments, withdrawals, and target allocations to make any required changes."